/**
 * SmsHealthBanner — bright red banner shown on the Waitlist page if the operator's
 * Twilio SMS is silently failing (3+ errors in the last hour) or the balance is low.
 * Polls /twilio/status on mount; auto-hides when things recover.
 */
import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Warning, ArrowSquareOut } from "@phosphor-icons/react";

export default function SmsHealthBanner() {
  const [status, setStatus] = useState(null);
  useEffect(() => {
    const load = () => api.get("/twilio/status").then((r) => setStatus(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);

  if (!status) return null;
  const problems = [];
  if (status.sms_failing) problems.push(`SMS failing (${status.sms_errors_last_hour} errors in the last hour)`);
  if (status.low_balance && status.balance_dollars != null) problems.push(`Twilio balance is only $${status.balance_dollars.toFixed(2)}`);
  if (!problems.length) return null;

  return (
    <div className="paper-card p-3 mb-4 bg-[#F1D7D2] border border-[#A5382A]/40" data-testid="sms-health-banner">
      <div className="flex items-start gap-2">
        <Warning size={18} color="#A5382A" weight="fill" className="mt-0.5 shrink-0" />
        <div className="flex-1">
          <div className="text-sm font-heading font-extrabold text-[#7A2B1E]">Your guests may not be getting texts</div>
          <div className="text-xs text-[#7A2B1E]/90 leading-snug">{problems.join(" · ")}. Top up your Twilio balance to keep SMS flowing.</div>
        </div>
        <a href="https://console.twilio.com/us1/billing/manage-billing/billing-overview" target="_blank" rel="noreferrer"
           className="btn-primary !py-1.5 !px-3 text-xs inline-flex items-center gap-1 shrink-0" data-testid="sms-health-topup">
          Top up <ArrowSquareOut size={12} color="#fff" />
        </a>
      </div>
    </div>
  );
}
